import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Icon } from 'antd';
import { get } from 'lodash';
import { LeadCalendarIcon } from '~/_shared/components/LeadCalendarIcon';
import { renderCadence } from '../LeadsTable/tableColumns';
import { limitCharacterLength } from '~/utils/formatters';
import {
  formatCurrency,
  formatDate,
  getPriority,
  hasCadences,
  hasSource,
  hasValue,
  isApifyOrigin,
} from './utils';
import {
  CalendarIcon,
  Content,
  Date,
  DateContainer,
  LeadInfo,
  LeadName,
  MainContent,
  Container,
  CadenceContainer,
  Value,
  SourceTag,
  PriorityIndicator,
} from './styles';

const LeadInfoSection = ({ item }) => (
  <LeadInfo>
    <DateContainer>
      <CalendarIcon />
      <Date>{formatDate(item.created_at)}</Date>
    </DateContainer>
    <LeadName>
      <Icon type="user" />
      {limitCharacterLength(item.name, 25)}
      {isApifyOrigin(item) && (
        <Icon
          type="thunderbolt"
          theme="filled"
          style={{ marginLeft: 6, color: '#FF7A00', fontSize: 12 }}
          title="Capturado automaticamente pela integração Apify"
        />
      )}
    </LeadName>
    {hasValue(item) && (
      <Value>{formatCurrency(item.value)}</Value>
    )}
    {hasSource(item) && !isApifyOrigin(item) && (
      <SourceTag>{item.additional_data.source}</SourceTag>
    )}
  </LeadInfo>
);

const CadenceSection = ({ item }) => {
  if (!hasCadences(item)) return null;
  
  return (
    <CadenceContainer>
      {renderCadence(item.additional_data.cadences)}
    </CadenceContainer>
  );
};

const DraggableCard = ({ props, item, showDrawer }) => {
  const { provided, snapshot } = props;
  const { innerRef, draggableProps, dragHandleProps } = provided;
  const { isDragging } = snapshot;
  const isRevised = get(item, 'additional_data.is_revised', false);

  return (
    <Container
      ref={innerRef}
      {...draggableProps}
      {...dragHandleProps}
      isDragging={isDragging}
      isRevised={isRevised}
      onClick={() => showDrawer(item)}
    >
      <PriorityIndicator priority={getPriority(item)} />
      <Content>
        <MainContent>
          <LeadInfoSection item={item} />
          <LeadCalendarIcon item={item} />
        </MainContent>
        <CadenceSection item={item} />
      </Content>
    </Container>
  );
};

export const LeadCard = ({ index, item, showDrawer }) => (
  <Draggable key={index} draggableId={String(item.id)} index={index}>
    {(provided, snapshot) => (
      <DraggableCard
        props={{ provided, snapshot }}
        item={item}
        showDrawer={showDrawer}
      />
    )}
  </Draggable>
);
